<template>
    <div>
        <modal-sold-sale-offer ref="soldSaleOfferDialog"/>
        <modal-cancel-sale-offer ref="cancelSaleOfferDialog" :sale-offer="saleOffer"/>
        <v-container class="grey lighten-5" fluid>
            <v-alert
                outlined
                color="deep-orange"
                prominent
                border="left"

                v-if="saleOffer.wmFinancing"
            >
            <strong>Oferta jest obsługiwana przez Wastemaster. <br>Przejdź do właściwej usługi, która jest widoczna dla klientów i do której należy wysyłać propozycje partnerom.<br>
              <router-link
                  :to="{name: 'sale-offer-details', params: { id: saleOffer.wmFinancingSaleOfferId }}"
              >
                Przejdź ...
              </router-link></strong>
          </v-alert>
            <v-row>
                <v-col cols="4">
                    <v-card class="mb-3">
                        <v-card-title>
                            Kopiuj link bezpośredni
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                v-model="directLink"
                                readonly
                                ref="directLink"
                            >
                                <template slot="append-outer">
                                    <v-btn @click="onDirectLinkCopyTriggered" title="Kopiuj do schowka.">
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-card-text>
                    </v-card>
                    <h4>Oferta sprzedaży</h4>
                    <div class="mt-3 elevation-1">
                        <v-data-table v-if="loadingDetails || details.length"
                                      :headers="headers"
                                      :items="details"
                                      :server-items-length="20"
                                      hide-default-header
                                      hide-default-footer
                                      :style="saleOffer.supervisor && saleOffer.supervisor.color ? 'background:' + saleOffer.supervisor.color : ''"
                                      :loading="loadingDetails"
                        >
                            <template v-slot:item.name="{ item }">
                                <span class="font-weight-medium">
                                  {{ item.name }}
                                </span>
                            </template>
                            <template v-slot:item.value="{ item }">
                                <a v-if="'Firma' === item.name"
                                   @click="onCompanyClicked"
                                >
                                    <span v-html="getCompanyName(item.value)"></span>
                                </a>
                                <span v-else-if="'Status' === item.name">
                                    {{ getSaleOfferStatusText(item.value) }}
                                </span>
                                <span v-else-if="'Utworzono' === item.name">
                                    {{ localDateTime(item.value) }}
                                </span>
                                <span v-else-if="'Sprzedaj z WM' === item.name">
                                  <router-link
                                      v-if="item.value"
                                      :to="{name: 'sale-offer-details', params: { id: item.value }}"
                                  >
                                    Przejdź ...
                                  </router-link>
                                  <em v-else class="text--blue">Nie</em>
                                </span>
                                <span v-else-if="'Opis' === item.name">
                                    <v-card-text v-html="item.value"></v-card-text>
                                </span>
                                <span v-else>
                                    {{ item.value }}
                                </span>
                            </template>
                        </v-data-table>
                        <div v-else>
                            Brak danych
                        </div>
                    </div>
                    <div class="my-3 d-flex text-center">
                        <v-btn v-if="canOfferBeApproved"
                               :disabled="loadingDetails"
                               ref="approveBtn"
                               @click="changeOnWm"
                               class="mx-1 flex-grow-1"
                               color="green lighten-1 white--text"
                        >
                            Zatwierdź
                        </v-btn>
                    </div>
                    <v-card class="my-3 text-center">
                        <v-card-title>
                            Edytuj ofertę
                        </v-card-title>
                        <v-card-text>
                            <v-text-field
                                v-model="saleOffer.cost"
                                :readonly="!canOfferBeModified"
                                type="number"
                                min="0"
                                step="1"
                                hint="Koszt w punktach."
                                persistent-hint
                            />
                            <v-textarea
                                v-model="saleOffer.description"
                                :readonly="!canOfferBeModified"
                                :counter="descriptionCharacterLimit"
                                :minlength="10"
                                :maxlength="descriptionCharacterLimit"
                                :rules="descriptionMaxLengthRule"
                                rows="10"
                                hint="Opis"
                                persistent-hint
                            />
                            <v-text-field
                                v-model="saleOffer.value"
                                :readonly="!canOfferBeModified"
                                label="Wartość zamówienia"
                                type="number"
                                class="wastemaster-input-elevation"
                            ></v-text-field>
                            <v-autocomplete
                                v-model="saleOffer.supervisor"
                                :items="supervisors"
                                item-value="id"
                                item-text="email"
                                label="Opiekun oferty"
                            >
                              <template v-slot:selection="data">
                                {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                              </template>
                              <template v-slot:item="data">
                                {{ data.item.name }} {{ data.item.surname }} - {{ data.item.email }}
                              </template>
                            </v-autocomplete>
                            <vue-dropzone id="dropzone" :options="dropzoneOptions"
                                        v-on:vdropzone-success="storeImageId"
                                        v-on:vdropzone-removed-file="removeImage"></vue-dropzone>
                            <div
                                class="mt-3 d-flex">
                                <v-btn v-if="canOfferBeModified"
                                       :disabled="loadingDetails"
                                       ref="saveBtn"
                                       @click="saveOffer"
                                       class="mx-1 flex-grow-1"
                                       color="green lighten-1 white--text"
                                >
                                    Zapisz
                                </v-btn>
                            </div>
                        </v-card-text>
                    </v-card>
                    <div class="my-3 text-center">
                        <v-btn v-if="canOfferBeSold || saleOffer.wmFinancingSaleOfferId"
                               :disabled="loadingDetails"
                               ref="soldBtn"
                               @click="sellOffer"
                               class="mx-1"
                               color="orange lighten-1"
                        >
                            Oznacz jako sprzedana
                        </v-btn>
                        <v-btn v-if="canOfferBeCancelled"
                               :disabled="loadingDetails"
                               ref="cancelBtn"
                               @click="cancelOffer"
                               class="mx-1"
                               color="red lighten-1"
                        >
                            Anuluj
                        </v-btn>
                    </div>
                    <div>
                        <v-card class="mt-3">
                            <v-card-title>
                                Wyślij e-mail do autora oferty
                            </v-card-title>
                            <v-card-text>
                                <!-- To get all available templates set :templates-to-list="[]". -->
                                <!-- To make the field empty set :templates-to-list="['']". -->
                                <SendEmail class="mt-3"
                                           v-if="isAdmin() || isTrader()"
                                           :receiver-entity-id="id"
                                           receiver-entity-name="SaleOffer"
                                           :templates-to-list="[
                                         'client_sale_offer_created',
                                         'sale-offer-assistance-available',
                                         'sale-offer-assistance-need-more-time',
                                         'sale-offer-assistance-solution-not-found',
                                         'sale_offer_created',
                                         'transfer-refund',
                                         'emitter-with-bdo',
                                         'emitter-without-bdo',
                                         'emitter-premium',
                                         'emitter-sell-with-waste-master',
                                     ]"
                                ></SendEmail>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div>
                        <v-card class="mt-3">
                            <v-card-title>
                                Przekaż do Partnera
                            </v-card-title>
                            <v-card-text>
                                <HandOverToPartner class="mt-3"
                                                   v-if="canBeHandedOverToPartner"
                                                   :target-sale-offer-id="id"
                                ></HandOverToPartner>
                                <div v-else>
                                    <strong>
                                        Oferta została już przekazana do Partnera.
                                    </strong>
                                </div>
                            </v-card-text>
                        </v-card>
                    </div>
                    <div class="mt-3">
                        <ImagesPreview :images="photos"/>
                    </div>
                </v-col>
                <v-col cols="8">
                    <div v-if="buyProposalsVisible">
                        <h4>Propozycje kupna</h4>
                        <v-btn @click="showAddBuyProposalModal()">Dodaj nową ofertę</v-btn>
                        <modal-add-buy-proposal ref="addBuyProposalDialog" :item="this.saleOffer"/>
                        <div class="mt-3">
                            <v-data-table
                                :headers="buyProposalHeaders"
                                :items="buyProposals"
                                :options="{itemsPerPage: 5}"
                                class="elevation-1 row-pointer"
                                :loading="loadingBuyProposals"
                                :search="buyProposalSearch"
                                @click:row="onBuyOfferClicked"
                            >
                                <template v-slot:top>
                                    <v-text-field
                                        v-model="buyProposalSearch"
                                        label="Szukaj"
                                        class="mx-4"
                                    ></v-text-field>
                                </template>
                                <template v-slot:item.user.id="{ item }">
                                    <router-link :to="{name: 'user-details', params: { id: item.user.id }}">
                                        #{{ item.user.id }}
                                    </router-link>
                                </template>
                                <template v-slot:item.status="{ item }">
                                    {{ getBuyProposalStatusText(item.status) }}
                                </template>
                                <template v-slot:item.type="{ item }">
                                    {{ getBuyProposalTypeText(item.type) }}
                                </template>
                                <template v-slot:item.createdAt="{ item }">
                                    {{ localDateTime(item.createdAtDto) }}
                                </template>
                                <template v-slot:item.id="{ item }">
                                    <v-btn v-if="item.status === 'P'"
                                           :disabled="loadingBuyProposals"
                                           ref="cancelBtn"
                                           @click="reject(item.id)"
                                           class="mx-1"
                                           color="red lighten-1"
                                    >
                                        Anuluj
                                    </v-btn>
                                </template>
                            </v-data-table>
                        </div>
                    </div>

                    <PotentiallyInterestedCompanies
                        v-if="potentiallyInterestedAvailable"
                        class="mt-5"
                        :saleOfferId="this.saleOfferId"
                        :wmFinancingSaleOfferId="this.saleOffer.wmFinancingSaleOfferId"
                        :potentiallyInterestedVisible="potentiallyInterestedVisible"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>
                            Notatki
                        </v-card-title>
                        <v-card-text>
                            <Notes
                                :id="this.saleOfferId"
                                url-add="/api/sale-offers/{parentId}/notes"
                                url-delete="/api/sale-offers/{parentId}/notes/{id}"
                                url-update="/api/sale-offers/{parentId}/notes/{id}"
                                url-list="/api/sale-offers/{parentId}/notes"
                            ></Notes>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import api from '../services/api';
import ImagesPreview from '../components/ImagesPreview';
import PotentiallyInterestedCompanies from '../components/PotentiallyInterestedCompanies';
import Notes from "@/components/notes/Notes";
import SendEmail from "@/components/SendEmail";
import HandOverToPartner from "@/components/HandOverToPartner"
import formatters from "@/mixins/formatters";
import permissions from "@/mixins/permissions";
import {getStatusText as getBuyProposalStatusText} from '@/enums/BuyProposalStatus';
import {getTypeText as getBuyProposalTypeText} from '@/enums/BuyProposalType';
import {getStatusText as getSaleOfferStatusText} from '@/enums/SaleOfferStatus';
import {getItems as getCompanyTypeItems} from "@/enums/CompanyType";
import ModalAddBuyProposal from "../components/ModalAddBuyProposal";
import ModalSoldSaleOffer from "../components/ModalSoldSaleOffer";
import ModalCancelSaleOffer from "@/components/ModalCancelSaleOffer.vue";
import {Auth} from "@/services/Auth";
import vue2Dropzone from "vue2-dropzone";

export default {
    components: {
      ModalCancelSaleOffer,
        ModalSoldSaleOffer,
        ModalAddBuyProposal,
        ImagesPreview,
        SendEmail,
        HandOverToPartner,
        Notes,
        PotentiallyInterestedCompanies,
        vueDropzone: vue2Dropzone,
    },
    mixins: [
        formatters,
        permissions,
    ],
    props: ['id'],
    data() {
        return {
            dialog: false,
            saleOfferId: null,

            companyType: '',
            companyTypes: [
                ...getCompanyTypeItems(),
            ],
            dropzoneOptions: {
              paramName: 'photo',
              url: `${process.env.VUE_APP_API_URL}/api/photos`,
              thumbnailWidth: 150,
              maxFilesize: 1024 * 20,
              maxFiles: 10,
              acceptedFiles: 'image/*',
              addRemoveLinks: true,
              headers: {
                'Authorization': `Bearer ${localStorage.getItem(Auth.TOKEN_KEY)}`
              }
            },
            saleOfferAttributesMap: {
                categoryName: 'Kategoria',
                company: 'Firma',
                status: 'Status',
                description: 'Opis',
                quantity: 'Ilość',
                postalCode: 'Kod pocztowy',
                city: 'Miasto',
                viewCount: 'Wyświetleń',
                createdAtDto: 'Utworzono',
                wmFinancingSaleOfferId: 'Sprzedaj z WM',
                value: 'Wartość',
                supervisor: 'Opiekun oferty',
                cancelReason: 'Powód anulowania',
            },
            headers: [
                {text: '', value: 'name'},
                {text: '', value: 'value'},
            ],
            buyProposalHeaders: [
                {text: 'Firma', value: 'company.name'},
                {text: 'Użytkownik', value: 'user.id'},
                {text: 'Kampania', value: 'user.campaignId'},
                {text: 'Status', value: 'status'},
                {text: 'Typ', value: 'type'},
                {text: 'Cena', value: 'price'},
                {text: 'Miasto', value: 'city'},
                {text: 'Kod pocztowy', value: 'postalCode'},
                {text: 'Transport', value: 'transport'},
                {text: 'Płatność', value: 'payment'},
                {text: 'Ważna do', value: 'validUntil'},
                {text: 'Akcje', value: 'id'},
            ],
            buyProposalSearch: '',
            saleOffer: {
                cost: 0,
                photosIds: [],
            },
            details: [],
            photos: [],
            buyProposals: [],
            supervisors: [],
            loadingDetails: false,
            loadingBuyProposals: false,
            loadingPhotos: false,
            wmAssistantStatus: null,
            addBuyProposal: false,
            viewerOptions: {
                inline: false,
                button: false,
                navbar: true,
                toolbar: {
                    zoomIn: true,
                    zoomOut: true,
                    oneToOne: true,
                    reset: true,
                    rotateLeft: true,
                    rotateRight: true
                },
                tooltip: true,
                movable: true,
                zoomable: true,
                rotatable: true,
                scalable: false,
                transition: true,
                fullscreen: true,
                keyboard: true,
            },

            appBaseUrl: process.env.VUE_APP_APP_URL,
            landingBaseUrl: process.env.VUE_APP_LANDING_URL,

            descriptionCharacterLimit: 2000,
            descriptionMaxLengthRule: [
                (v) =>
                    (v && v.length <= this.descriptionCharacterLimit) ||
                    `Opis może mieć maksymalnie ${this.descriptionCharacterLimit} znaków`
            ],
            admins: [],
        }
    },
    methods: {
        async reject(id) {
            try {
                await api.post(`/api/buy-proposals/${id}/reject`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się anulować oferty.',
                    error,
                });

                return;
            }

            await this.loadBuyProposals();
        },
        async showAddBuyProposalModal() {
            this.$refs.addBuyProposalDialog
                .open()
        },
        async loadDetails() {
            this.loadingDetails = true;

            const saleOfferResponse = await api.get(`/api/sale-offers/${this.saleOfferId}`);
            this.saleOffer = saleOfferResponse.data
            this.saleOffer.photosIds = []
            this.wmAssistantStatus = saleOfferResponse.data.wmAssistantStatus;
            this.details.length = 0; // Trick to empty the array without changing the reference!

            for (const [key, value] of Object.entries(saleOfferResponse.data)) {
                if (key in this.saleOfferAttributesMap) {
                    this.details.push({
                        name: this.saleOfferAttributesMap[key],
                        value: this.prepareSaleOfferDetailsValue(key, value),
                    })
                }
            }

            this.loadingDetails = false;
        },
        async loadSupervisors() {
          const supervisorsResponse = await api.get(`/api/users?role=ROLE_SUPERVISOR`);
          this.supervisors = [{id: 0, email: "Wybierz opiekuna -"}].concat(supervisorsResponse.data.items)
        },
        prepareSaleOfferDetailsValue(name, value) {
            if (name === 'company') {
                value = value['name'];
            }
            if (name === 'supervisor') {
                value = value ? (value['name'] + ' ' + value['surname'] + ' - ' + value['email']) : '';
            }

            return value;
        },

        async loadBuyProposals(campaignId) {
            this.loadingBuyProposals = true;

            const params = {
                saleOfferId: this.saleOfferId,
                type: 'others'
            }

            if (campaignId) {
                params.campaignId = campaignId;
            }

            const buyProposalResponse = await api.get(`/api/buy-proposals`, {
                params
            });

            this.buyProposals = buyProposalResponse.data.items;

            this.loadingBuyProposals = false;
        },
        async loadPhotos() {
            const saleOfferPhotosResponse = await api.get('/api/photos', {
                params: {
                    saleOfferId: this.saleOfferId
                }
            });

            let photos = saleOfferPhotosResponse.data.items;

            photos.forEach((photo, index, photos) => {
                this.photos.push(photos[index].url);
            });

            // let photos = [];
            //
            // setTimeout(() => {
            //     photos = [
            //         {url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Electronic_waste_at_Agbogbloshie%2C_Ghana.jpg/2880px-Electronic_waste_at_Agbogbloshie%2C_Ghana.jpg'},
            //         {url: 'https://lh3.googleusercontent.com/proxy/ZB_a-2hEufK051iyXBI6H8PUzmUuAdllPzvpnGyGPA7GsSQ-DacmV49bBGXkxUjkFPBMb9vn6iCvFRaiQgxmZJEH3bFZkbcrs4jZMR1hXSaAUeqoxSEDYTTup2J-kwZQlnF3-Q'},
            //         {url: 'https://d.allegroimg.com/s1024/0c28ad/23c2cc80412d80327d25727931cd'},
            //     ];
            //
            //     photos.forEach((photo, index, photos) => {
            //         this.photos.push(photos[index].url);
            //     });
            // }, 2000);
        },
        async approveOffer() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.post(`/api/sale-offers/${this.saleOfferId}/approve`)
                .then((response) => {
                    this.details.forEach((object) => {
                        if (object.name === 'Status') {
                            // Update status.
                            object.value = response.data.status;
                            this.saleOffer.status = object.value;
                        }
                    });

                    const expectedStatus = 'A';

                    if (expectedStatus !== response.data.status) {
                        this.$root.$emit('notifyError', {
                            html:
                                'Nie udało się zatwierdzić oferty - ' +
                                `server zwrócił status "${response.data.status}" zamiast "${expectedStatus}".`
                        });

                        return;
                    }

                    this.$root.$emit('notifySuccess', {
                        html: 'Oferta została pomyślnie zatwierdzona.'
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zatwierdzić oferty.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },
        async changeOnWm() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.put(`/api/sale-offers/${this.saleOfferId}/sell-with-wm`)
                .then(() => {
                    this.$root.$emit('notifySuccess', {
                        html: 'Oferta została poprawie przekształcona.'
                    });

                    this.loadDetails();
                })
                .catch((error) => {
                    console.log(error);
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się przekształcić oferty.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },
        async saveOffer() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            let data = {
                cost: this.saleOffer.cost,
                supervisor: typeof this.saleOffer.supervisor === 'object' && this.saleOffer.supervisor !== null? this.saleOffer.supervisor.id : this.saleOffer.supervisor
            }

            data.description = this.saleOffer.description;

            data.responsiblePerson = this.saleOffer.responsiblePerson;
            data.value = this.saleOffer.value;

            if (this.saleOffer.photosIds) {
              data.photosIds = this.saleOffer.photosIds;
            }

            await api.put(
                `/api/sale-offers/${this.saleOfferId}`, data)
                .then((response) => {
                    this.saleOffer = response.data;
                    this.loadDetails();
                    this.$root.$emit('notifySuccess', {
                        html: 'Oferta została pomyślnie zaktualizowana.'
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się zaktualizować oferty.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },
        async cancelOffer() {
            if (this.loadingDetails) {
                return;
            }

            this.$refs.cancelSaleOfferDialog.open()
        },
        async sellOffer() {
            if (this.loadingDetails) {
                return;
            }

            this.loadingDetails = true;
            await api.post(`/api/sale-offers/${this.saleOfferId}/sell`, {responsiblePerson: this.saleOffer.responsiblePerson?.id, value: this.saleOffer.value})
                .then((response) => {
                    this.details.forEach((object) => {
                        if (object.name === 'Status') {
                            // Update status.
                            object.value = response.data.status;
                            this.saleOffer.status = object.value;
                        }
                    });

                    const expectedStatus = 'S';

                    if (expectedStatus !== response.data.status) {
                        this.$root.$emit('notifyError', {
                            html:
                                'Nie udało się oznaczyć oferty jako sprzedana - ' +
                                `server zwrócił status "${response.data.status}" zamiast "${expectedStatus}".`
                        });

                        return;
                    }

                    this.$root.$emit('notifySuccess', {
                        html: 'Oferta została pomyślnie oznaczona jako sprzedana.'
                    });
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się oznaczyć oferty jako sprzedana.',
                        error
                    });
                })
                .finally(() => {
                    this.loadingDetails = false;
                });
        },
        isSaleOfferApproved() {
            return this.saleOffer && this.saleOffer.status === 'A';
        },
        getBuyProposalStatusText(status) {
            return getBuyProposalStatusText(status);
        },
        getBuyProposalTypeText(status) {
            return getBuyProposalTypeText(status);
        },
        getSaleOfferStatusText(status) {
            return getSaleOfferStatusText(status);
        },
        getCompanyName(name) {
            if (null !== name) {
                name = String(name).trim();
            } else {
                name = '';
            }

            if ('' !== name) {
                return name;
            }

            return `<i>* Brak nazwy *</i>`;
        },
        onDirectLinkCopyTriggered() {
            const textToCopy = this.$refs.directLink.$el.querySelector('input');
            textToCopy.select();
            document.execCommand('copy');
        },
        onCompanyClicked() {
            this.$router
                .push({name: 'company-details', params: {id: this.saleOffer.company.id}});
        },
        onBuyOfferClicked(buyOffer) {
            this.$router
                .push({name: 'buy-offer-details', params: {id: buyOffer.id}});
        },
        async showSoldSaleOfferModal() {
            this.$refs.soldSaleOfferDialog
                .open()
        },
        async getAdminUsers() {
            api.get('/api/users?showAdmins=true')
                .then((response) => {
                    this.admins = response.data.items;
                })
                .catch((error) => {
                    this.$root.$emit('notifyError', {
                        html: 'Nie udało się pobrać listy użytkowników.',
                        error,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        storeImageId(event, image) {
          this.saleOffer.photosIds.push(image.id);
        },
        removeImage(image) {
          this.saleOffer.photosIds = this.saleOffer.photosIds.filter(photo => photo !== image.id);
        },
    },
    computed: {
        directLink() {
            let link = this.landingBaseUrl.replace('mamodpad', 'gielda') + '/oferta/oferta-/' + this.saleOfferId;

            if (localStorage.getItem('code')) {
              link += '?s=' + localStorage.getItem('code');
            }

            return link;
        },
        potentiallyInterestedAvailable() {
            return true;
        },
        buyProposalsVisible() {
            return this.isAdmin() || this.isTrader();
        },
        potentiallyInterestedVisible() {
            return this.isAdmin() || this.isTrader();
        },
        canOfferBeApproved() {
            return (this.isAdmin() || this.isTrader()) &&
                this.saleOffer &&
                !this.isSaleOfferApproved();
        },
        canOfferBeModified() {
            return this.isAdmin() || this.isTrader();
        },
        canBeHandedOverToPartner() {
            return (this.isAdmin() || this.isTrader()) && this.saleOffer && !this.saleOffer.handedOverToPartner
        },
        canOfferBeCancelled() {
            return (this.isAdmin() || this.isTrader()) &&
                this.saleOffer &&
                !['C', 'S'].includes(this.saleOffer.status);
        },
        canOfferBeSold() {
            return (this.isAdmin() || this.isTrader()) &&
                this.saleOffer && this.saleOffer.status === 'A';
        },
        canOfferBeChangeOnWm() {
            return (this.isAdmin() || this.isTrader()) && this.saleOffer.status !== 'S';
        },
    },
    async created() {
        try {
            this.saleOfferId = this.id; // Store new user id in the local variable.
            await this.loadDetails();
            await this.loadPhotos();
            await this.getAdminUsers();
            await this.loadSupervisors();

            if (this.buyProposalsVisible) {
                await this.loadBuyProposals(null);
            }
        } catch (e) {
            void (0);
        }
    },
    async beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.saleOfferId = to.params.id; // Store new user id in the local variable.
        await this.loadDetails();
        await this.loadPhotos();

        if (this.buyProposalsVisible) {
            await this.loadBuyProposals(null);
        }
    },
}
</script>

<style scoped>
.v-data-table
/deep/
tbody
/deep/
tr:hover:not(.v-data-table__expanded__content) {
    background: #ffffff !important;
}
</style>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
    cursor: pointer;
}
</style>